import React from "react";

interface StethoscopeIconProps {
  className?: string;
}

export const StethoscopeIcon: React.FC<StethoscopeIconProps> = ({
  className,
}) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_stethoscope)">
      <path
        d="M15.4502 1.1666V3.29663"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9072 1.1666V3.29663"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6699 16.5513L19.1765 22.4673L21.6831 16.5513"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.9062 2.23176H24.169C25.9381 2.23176 27.2153 3.92486 26.7293 5.62575L24.6091 13.0458C23.9163 15.4704 21.7001 17.142 19.1784 17.142C16.6566 17.142 14.4404 15.4704 13.7477 13.0458L11.6275 5.62575C11.1415 3.92486 12.4188 2.23176 14.1878 2.23176H15.4506"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.36133 20.3368V17.7275C4.36133 15.6394 6.05416 13.9467 8.14236 13.9467C10.2306 13.9467 11.9234 15.6394 11.9234 17.7275V23.2055C11.9234 25.2091 13.5477 26.8334 15.5515 26.8334C17.5552 26.8334 19.1796 25.2091 19.1796 23.2055V22.4668"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16699 23.5314C1.16699 25.296 2.59755 26.7264 4.36223 26.7264C6.1269 26.7264 7.55747 25.296 7.55747 23.5314C7.55747 21.7668 6.1269 20.3364 4.36223 20.3364C2.59755 20.3364 1.16699 21.7668 1.16699 23.5314Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5625 23.5316C3.5625 23.9727 3.92015 24.3303 4.36131 24.3303C4.80246 24.3303 5.16012 23.9727 5.16012 23.5316C5.16012 23.0904 4.80246 22.7328 4.36131 22.7328C3.92015 22.7328 3.5625 23.0904 3.5625 23.5316Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_stethoscope">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
